module.exports = __webpack_public_path__ + "img/logo-agetic-small.4673a07b.png";